import React, { useState, useEffect, useRef } from 'react';
import { CSVLink } from 'react-csv';
import { exportToPDF, printTableFromHtml, generateCSVData } from '../../services/exportService';

const RadioReportView = () => {
  const [titleFilter, setTitleFilter] = useState('');
  const [reportData, setReportData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [summary, setSummary] = useState({
    listenedCount: 0,
    totalDuration: 0,
    purchasedCount: 0,
  });

  const tableRef = useRef(null);

  useEffect(() => {
    fetchReportData();
  }, []);

  useEffect(() => {
    applyFilter();
  }, [reportData, titleFilter]);

  const fetchReportData = () => {
    const dummyData = [
      {
        title: 'Panchatantra Story',
        type: 'Story',
        listenedDuration: 25,
        isPurchased: true,
        listenCount: 3,
        playlistCount: 5,
        lastListened: '2025-05-12',
      },
      {
        title: 'ABC Song',
        type: 'Song',
        listenedDuration: 10,
        isPurchased: false,
        listenCount: 1,
        playlistCount: 2,
        lastListened: '2025-05-11',
      },
      {
        title: 'Yoga Basics',
        type: 'Learning',
        listenedDuration: 45,
        isPurchased: true,
        listenCount: 2,
        playlistCount: 3,
        lastListened: '2025-05-09',
      },
    ];
    setReportData(dummyData);
  };

  const applyFilter = () => {
    let filtered = [...reportData];

    if (titleFilter.trim()) {
      filtered = filtered.filter(d => d.title.toLowerCase().includes(titleFilter.trim().toLowerCase()));
    }

    setFilteredData(filtered);

    const totalDuration = filtered.reduce((sum, item) => sum + item.listenedDuration, 0);
    const purchasedCount = filtered.filter(item => item.isPurchased).length;
    setSummary({
      listenedCount: filtered.length,
      totalDuration,
      purchasedCount,
    });
  };

  const columns = ['#', 'Radio Title', 'Duration', 'Playlist Count'];
  const data = filteredData.map((item, i) => [
    i + 1,
    item.title,
    `${item.listenedDuration} mins`,
    item.playlistCount,
  ]);

  const handleExportPDF = () => {
    exportToPDF('Radio Usage Report', columns, data, 'RadioUsageReport.pdf');
  };

  const handlePrint = () => {
    if (tableRef.current) {
      printTableFromHtml(tableRef.current.innerHTML, 'Radio Usage Report');
    }
  };

  return (
    <div className="container mt-4">
      <div className="card p-3">

        {/* Filter */}
        {/* <div className="row mb-3">
          <div className="col-md-12">
            <input
              type="text"
              className="form-control"
              placeholder="Filter by Radio Title"
              value={titleFilter}
              onChange={e => setTitleFilter(e.target.value)}
            />
          </div>
        </div> */}

        {/* Export Buttons */}
        <div className="card-header d-flex justify-content-between align-items-center mb-3 px-0 border-0">
          <h3 className="mb-0">Radio Report</h3>

          <div className="d-flex gap-2">
            <button className="btn btn-outline-danger" onClick={handleExportPDF}>
              Export PDF
            </button>

            <CSVLink
              filename="RadioUsageReport.csv"
              className="btn btn-outline-info"
              data={generateCSVData(columns, data)}
            >
              Export CSV
            </CSVLink>

            <button className="btn btn-outline-dark" onClick={handlePrint}>
              Print
            </button>
          </div>
        </div>

        {/* Summary */}
        {/* <div className="row mb-4">
          <div className="col">
            <div className="p-3 bg-light border rounded text-center">
              <div className="fw-bold">Total Listening Time</div>
              <div>
                {summary.totalDuration} mins ({(summary.totalDuration / 60).toFixed(2)} hrs)
              </div>
            </div>
          </div>
        </div> */}

        {/* Table */}
        <div className="table-responsive" ref={tableRef}>
          <table className="table table-bordered mb-0">
            <thead className="table-light">
              <tr>
                {columns.map((col, i) => (
                  <th key={i} className="text-center">{col}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                data.map((row, i) => (
                  <tr key={i}>
                    {row.map((cell, j) => (
                      <td key={j} className="text-center">{cell}</td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columns.length} className="text-center py-3">No data found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
};

export default RadioReportView;
